import {
  TableBody,
  TableCell,
  Table as TableComponent,
  TableHead,
  TableRow,
} from "@/view/components/ui/table";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

interface GrayCardProps {
  title: string;
  headers: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rows: any[][];
  hasVerticalScroll?: boolean;
}

export const GrayTableCard = ({
  title,
  headers,
  rows,
  hasVerticalScroll = false,
}: GrayCardProps) => {
  const [expanded, setExpanded] = useState(false);

  const table = (
    <TableComponent className="mt-3 w-full">
      <TableRow className="border-y font-medium">
        {headers.map((header, i) => (
          <TableHead
            className="text-center text-black01 first:text-left first:font-semibold last:text-right"
            key={`${header}-${i}`}
          >
            {header}
          </TableHead>
        ))}
      </TableRow>

      <TableBody>
        {rows.map((row) => (
          <TableRow key={row[0]}>
            {row.map((cell, i) => (
              <TableCell
                key={`${cell}-${i}`}
                className="text-center first:text-left first:font-semibold first:text-black01 last:text-right"
              >
                {cell}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </TableComponent>
  );

  return (
    <div className="overflow-x-auto rounded-lg bg-white02 p-3">
      <div
        onClick={() => setExpanded((prev) => !prev)}
        className="flex cursor-pointer items-center justify-between"
      >
        <p className="font-semibold">{title}</p>

        {expanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {expanded && (
        <>
          {hasVerticalScroll ? (
            <div className="max-h-[200px] overflow-y-auto">{table}</div>
          ) : (
            table
          )}
        </>
      )}
    </div>
  );
};
